export default __webpack_public_path__ + "static/media/seLogerConstruire.7a67cefc.svg";